import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import TaxDiagnosticMessage from './TaxDiagnosticMessage/TaxDiagnosticMessage';

const TaxDiagnosticMessagePicker = ({ resource }) => {
  return resource.withRelationship(
    fr.relationships.taxDiagnosticMessage.name,
    (rel) => (
      <TaxDiagnosticMessage relationship={rel.link('related')} />
    ),
    () => null,
  );
};

TaxDiagnosticMessagePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
TaxDiagnosticMessagePicker.defaultProps = {
};

export default TaxDiagnosticMessagePicker;
